import { Button, Card, DatePicker, Message, Space, Table } from "@arco-design/web-react";
import { Currency, Number } from "@/components/Numeric";
import { useCallback, useEffect, useState } from "react";
import { InventoryAPI } from "@/apis/material";
import { ItemSelect } from "@/components/ItemSelect";
import { LotSelect } from "@/components/LotSelect";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

export const InventoryEvaluation = () => {
    const [data, setData] = useState([]);

    const [itemId, setItemId] = useState();
    const [lot, setLot] = useState();
    const [dateRange, setDateRange] = useState([dayjs().add(-30, 'day').format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")]);

    useEffect(() => {
        setLot(undefined);
    }, [itemId]);

    const search = useCallback(async () => {
        if (!itemId) {
            Message.warning("Please select item!");
            return;
        }
        const result = await InventoryAPI.evaluation(1, {
            itemId,
            lot,
            beginDate: dateRange?.[0],
            endDate: dateRange?.[1]
        });
        for (let index = 0; index < result.length; index++) {
            const element = result[index];
            const prev = index <= 0 ? { endQty: 0, endValue: 0 } : result[index - 1];
            element.id = index;
            element.endQty = prev.endQty + element.changeQty;
            element.endValue = prev.endValue + element.amount;
        }
        setData(result);
    }, [itemId, lot, dateRange]);

    const getDocUrl = (docId, docType) => {
        switch (docType) {
            case "Receipt":
                return `/workspace/purchasing/receipt/${docId}`;
            case "Fulfillment":
                return `/workspace/sales/so-fulfillment/${docId}`;
            case "WO Raw Item":
            case "WO Finished Item":
                return `/workspace/manufacturing/wo-fulfillment/${docId}`;
            case "Adjustment":
                return `/workspace/material/inventory_adjustment/${docId}`;
            case "New Inventory":
                return `/workspace/material/inventory_new_inventory/${docId}`;
            default:
                return null;
        }
    }

    return (
        <Card title="Inventory Evaluation" extra={
            <Space>
                <ItemSelect style={{ width: 180 }} value={itemId} onChange={setItemId} placeholder="Item Name" />
                <LotSelect style={{ width: 180 }} value={lot} itemId={itemId} onChange={setLot} placeholder="Lot" allowClear />
                <DatePicker.RangePicker
                    defaultValue={[dayjs().add(-30, 'day'), dayjs()]}
                    onChange={(val) => setDateRange(val)}
                />
                <Button type="primary" onClick={search}>Search</Button>
            </Space>
        }>
            <Table
                rowKey="id"
                columns={[
                    { title: "Date", dataIndex: "date" },
                    { title: "Doc#", render: (col, record) => <Link to={getDocUrl(record.docId, record.docType)}>{record.docNo}</Link> },
                    { title: "Lot#", dataIndex: "lot" },
                    { title: "Qty Change", render: (col, record) => <Number value={record.changeQty} /> },
                    { title: "Amount", render: (col, record) => <Currency value={record.amount} /> },
                    { title: "End Qty", render: (col, record) => <Number value={record.endQty} /> },
                    { title: "End Value", render: (col, record) => <Currency value={record.endValue} /> },
                ]}
                scroll={{ y: 'calc(100vh - 280px)' }}
                data={data}
            />
        </Card>
    );
}
